var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.getLoading)?_c('div',{staticClass:"custom__spinWrap"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"custom__position"},[_c('div',{attrs:{"id":"cssload-box-loading"}})])
}]

export { render, staticRenderFns }